export const fxContainerTestId = 'fx-calculator-slice';
